<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>سیاست حفظ حریم‌ خصوصی</h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>

            <div class="card card-style">
                <div class="content">
                    <div class="text-center">
                        <i class="fa fa-shield-alt color-green1-dark fa-3x pt-3 icon-size ml-0"></i>
                    </div>
                    <h1 class="text-center font-weight-bold font-18">سیاست حفظ حریم خصوصی تَسکینو</h1>
                    <p class="text-justify">
                        امروزه با گسترش جریان اطلاعات و استفاده روزمره کاربران از اینترنت و وسایل ارتباطی، حریم خصوصی کاربران به یکی از جدی‌ترین دغدغه‌ها تبدیل شده‌است. نگرانی بسیاری از کاربران، محفوظ ماندن اطلاعات شخصی همچنین شماره موبایل، نام و نام خانوادگی و ایمیل است که برای ثبت نام و لاگین شدن به ما می‌سپارند. لازم به ذکر است ما نیز اهمیت این موضوع را درک می‌کنیم و حریم خصوصی کاربران برای ما اهمیت بسیاری دارد. در ادامه سیاست حفظ حریم خصوصی اپلیکیشن تسکینو، برای کاربران آورده شده است. .
                    </p>
                    <h2 class="font-weight-bold font-16">
                        چه اطلاعاتی از شما دریافت می‌شود؟
                    </h2>
                    <p class="text-justify">
                        برای ثبت نام در اپلیکشین تَسکینو لازم است تا اطلاعاتی مانند نام و نام خانوادگی، شماره تلفن همراه و آدرس ایمیل خود را در اختیار ما قرار دهید.
                    </p>
                    <h2 class="font-weight-bold font-16">
                        چگونه از اطلاعات شما محافظت می‌شود؟
                    </h2>
                    <p class="text-justify">
                        در طراحی اپلیکیشن تَسکینو سعی شده که بالاترین سطوح امنیتی نرم‌افزاری در نظر گرفته شود. در زمان دانلود اپلیکیشن و ثبت نام، درخواست کد فعالسازی، درخواست‌ها و خدمات بر روی سرورهای ایمن ما ذخیره و توسط فایروال‌های مستحکم محافظت خواهند شد. شماره تماس و آدرس ایمیل و رمز عبور کاربران نیز به صورت رمزنگاری‌شده در بستر امن HTTPS به وب‌سایت ما منتقل و برای تعاملات بعدی نگهداری خواهند شد.
                    </p>
                    <h2 class="font-weight-bold font-16">
                        چه استفاده‌ای اطلاعات شما خواهد شد؟
                    </h2>
                    <p class="text-justify">
                        چه از نظر قانونی چه از نظر اخلاقی ما موظف به صیانت از اطلاعات شما هستیم. اطلاعات شما صرفاً به صورت کدگذاری‌شده نگهداری می‌شوند. همچنین به کاربران اطمینان می دهیم ایمیل‌ها و پیام‌های تبلیغاتی را برای کاربران‌مان ارسال نخواهیم کرد.
                    </p>
                    <h2 class="font-weight-bold font-16">
                        چه کسانی به اطلاعات شما دسترسی دارند؟
                    </h2>
                    <p class="text-justify">
                        همکاران بخش پشتیبانی و فنی پس از دریافت نام کاربری و رمز عبور از شما، در داخل محیط اپلیکیشن، به برخی از اطلاعات شما دسترسی دارند آن هم برای ارائه پشتیبانی بهتر و خدمات با کیفیت‌تر مورد استفاده قرار می‌گیرد. بدیهی است به غیر از این حالت دسترسی به اطلاعات شما وجود نخواهد داشت. تمامی اطلاعات شما نزد ما محفوظ خواهد ماند و در اختیار افراد یا سازمان‌های دیگری قرار نخواهد گرفت. بدیهی است که مراجع قانونی با ارائه حکم دادگاه قادرند به این اطلاعات دسترسی داشته باشند. به طور کلی ما موظفیم از اطلاعات شما حفاظت و حراست نماییم.
                    </p>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                info: null
            }
        },
        methods: {
            GetCompanyItem() {
                this.$http.get("Person/GetLocalCompany")
                   .then(data => {
                        this.info = data.data;
                    });
            },
        },
        created() {
            this.GetCompanyItem();
        }
    }
</script>